import clsx from 'clsx';
import React from 'react';

type StatsCardProps = {
  header: string;
  value: string;
  version?: 'liquid' | 'solid';
};

function camelCaseToWords(s: string) {
  const result = s.replace(/([A-Z])/g, ' $1');
  return result.charAt(0).toUpperCase() + result.slice(1);
}

const StatsCard = ({ header, value, version = 'solid' }: StatsCardProps) => {
  return (
    <div
      className={clsx(
        'min-w-[290px] h-[140px] border bg-white flex flex-col justify-center rounded-[10px] px-4 overflow-hidden m-1',
        {
          'flex-grow': version === 'liquid',
        }
      )}
    >
      <div className='text-[17px] text-[#555555] font-normal'>
        {camelCaseToWords(header)}
      </div>
      <div className='text-[30px] font-semibold'>{value}</div>
    </div>
  );
};

export default StatsCard;
